import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can use the npm search bar to find packages to use in your projects. npm search uses npms and the npms analyzer; for more information on both, see `}<a parentName="p" {...{
        "href": "https://npms.io/about"
      }}>{`https://npms.io/about`}</a>{`.`}</p>
    <h2>{`Searching for a package`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In the search bar, type a search term and press `}<strong parentName="p">{`Enter`}</strong>{`. As you type, possible choices will appear.`}</p>
        <Screenshot src="/packages-and-modules/getting-packages-from-the-registry/search-qr.png" alt="Screenshot of a search text box" mdxType="Screenshot" />
        <Screenshot src="/packages-and-modules/getting-packages-from-the-registry/search-qr-results.png" alt="Screenshot of the search text box and search results" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`To list packages ranked according to `}<a parentName="p" {...{
            "href": "#package-search-rank-criteria"
          }}>{`package search rank criteria`}</a>{`, in the left sidebar, under "Sort packages", click the criterion. For example, to sort packages by popularity, click "Popularity".`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the package search results list, click the name of the package.`}</p>
      </li>
    </ol>
    <h2>{`Package search rank criteria`}</h2>
    <p>{`Often, there are dozens or even hundreds of packages with similar names and/or similar purposes. To help you decide the best ones to explore, each package has been ranked according to four criteria using the npms analyzer:`}</p>
    <h3>{`Popularity`}</h3>
    <p>{`Popularity indicates how many times the package has been downloaded. This is a strong indicator of packages that others have found to be useful.`}</p>
    <h3>{`Quality`}</h3>
    <p>{`Quality includes considerations such as the presence of a README file, stability, tests, up-to-date dependencies, custom website, and code complexity.`}</p>
    <h3>{`Maintenance`}</h3>
    <p>{`Maintenance ranks packages according to the attention they are given by developers. More frequently maintained packages are more likely to work well with the current or upcoming versions of the npm CLI, for example.`}</p>
    <h3>{`Optimal`}</h3>
    <p>{`Optimal combines the other three criteria (popularity, quality, maintenance) into one score in a meaningful way.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      